class ShelfProductVariantController {
    constructor(config, trolleyService, analytics, settings) {
        this.config = config;
        this.trolleyService = trolleyService;
        this.analytics = analytics;
        this.settings = settings;
    }

    $onInit() {
        this.defaultImagePath = this.config.DefaultProductImageSmall;
    }

    gtmProductClickDataPush() {
        this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
    }
}

const shelfProductVariantComponentDefinition = {
    bindings: {
        product: '<',
        totalVariants: '=',
    },
    controller: ['config', 'TrolleyService', 'AnalyticsService', 'Settings', ShelfProductVariantController],
    template: require('./shelf-product-variant.component.html').trim(),
};

module.exports = {
    ShelfProductVariantController,
    shelfProductVariantComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-variant.component.js